/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        
        $(document).ready(function(){
          // new menu
          $('.header-search-btn').click(function(){
            $('.header-search-field').toggleClass('md:hidden');
          });
          $('.togglebtn').click(function(){
            $('.navbar').toggleClass('hidden');
          });
          //pop over
          $('[data-toggle="popover"]').popover();
          // slider
          $('.flexslider').flexslider({
            animation: "slide"
          });
          // mobile menu
          $('.jx-close').on('click', function(){
            $('body').toggleClass('-menu-opened');
          });

          $('.tp-header .tp-header__searchbtn').on('click', function(e){
            e.preventDefault();
            $('i.far').toggleClass('fa-search fa-times-circle');
            $('.tp-header__searchform').toggleClass('-active');
          });
        });

        // mailchimp footer
        var mailchimpConfig = {
          baseUrl: 'mc.us13.list-manage.com',
          uuid: '29e5e905f3a5d21e3de092eec',
          lid: '230197f412'
        };
    
        var chimpPopupLoader = document.createElement("script");
        chimpPopupLoader.src = 'https://s3.amazonaws.com/downloads.mailchimp.com/js/signup-forms/popup/embed.js';
        chimpPopupLoader.setAttribute('data-dojo-config', 'usePlainJson: true, isDebug: false');
    
        jQuery(function ($) {
          document.body.appendChild(chimpPopupLoader);
    
          jQuery("#footer-sub").on("click", function (e) {
            e.preventDefault();
            require(["mojo/signup-forms/Loader"], function (L) { L.start({"baseUrl": mailchimpConfig.baseUrl, "uuid": mailchimpConfig.uuid, "lid": mailchimpConfig.lid})});
            document.cookie = 'MCPopupClosed=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;';
            document.cookie = 'MCPopupSubscribed=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;';
          });
    
        });


      }
    },
    // Test 
    'home': {
      finalize: function() {
        $(document).on('scroll', function () {
          if ($(this).scrollTop() >= $('.hero-text').position().top) {
            $('header').addClass('bg-brand-color');
          } else {
            $('header').removeClass('bg-brand-color');
          }
        });

        $(document).ready(function(){
      
      
          $('.gas-btn').click(function() {
            $('.routeitem-1').removeClass('d-none');
            $(this).addClass('d-visiable');
            $('.routeitem-2').addClass('d-none');
            $('.routeitem-3').addClass('d-none');
          });
          $('.life-btn').click(function() {
            $('.routeitem-2').removeClass('d-none');
            $(this).addClass('d-visiable');
            $('.routeitem-1').addClass('d-none');
            $('.routeitem-3').addClass('d-none');
          });
          $('.cul-btn').click(function() {
            $('.routeitem-3').removeClass('d-none');
            $(this).addClass('d-visiable');
            $('.routeitem-1').addClass('d-none');
            $('.routeitem-2').addClass('d-none');
          });
      
          $('ul li .tabbtn').click(function() {
            $('ul li .tabbtn').removeClass('active');
            $(this).addClass('active');
          });

        });
      }
    },
    // Gallery
    'gallery': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        $(document).ready(function(){
          $('#carousel').flexslider({
            animation: "slide",
            controlNav: false,
            animationLoop: false,
            slideshow: false,
            itemWidth: 80,
            itemMargin: 16,
            asNavFor: '#slider'
          });
         
          $('#slider').flexslider({
            animation: "slide",
            controlNav: false,
            animationLoop: false,
            slideshow: false,
            sync: "#carousel"
          });
      });
      }
    },
    // Route
    'page_template_template_route': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        $(document).ready(function(){

          $('.js-close').on('click', function(e){
            e.preventDefault();
            $('.tp-popup').removeClass('-active');
            $('.tp-route__wrap').show();
            $('.tp-route__media').show();
          });
          $('.tp-post--directory').click(function(e){
            e.preventDefault();
            var post_id = $(this).attr('rel'); //this is the post id
            var post_link = $(this).attr('href');
            var post_next = $('.tp-route__list article a[rel=' + post_id + ']').parent().next().clone(true);
            var post_address = $(this).find('.tp-post__location').attr('data-location');
            var nonce = $(this).attr('data-nonce');
            $.ajax({
                url: myapiurl.ajax_url,
                dataType: 'json',
                type: 'post',
                data: {
                    action: 'load_attraction',
                    post_id: post_id,
                    nonce: nonce,
                },
                success: function(result) {
                    // console.log(result);
                    for (var j = 0; j < landmark_ids.length; j++) {
                      if (landmark_ids[j] == post_id) {
                         var imageUrl = landmark_covers[j];
                      }
                    }                    
                    $('.tp-popup__title').html(result.post_title);
                    $('.tp-popup__content').html(result.post_content);
                    $('.tp-popup__media').css('background-image', 'url(' + imageUrl + ')');
                    $('.tp-popup__link').prop('href', post_link);
                    $('.tp-popup__address').html(post_address);
                    $('.tp-popup').addClass('-active');
                    $('.tp-route__wrap').hide();
                    $('.tp-route__media').hide();
                    if ((post_next).length > 0) {
                      $('.tp-popup__related').show();
                      $('.tp-popup__next').html(post_next);
                    } else {
                      $('.tp-popup__related').hide();
                    }
                    $(window).scrollTop($('.tp-popup__media').offset().top);
                }
            });
            return false;            
          });
        });
      }
    },    
    'homepage': {
      finalize: function() {
        $(document).ready(function(){

            $('.flexslider').flexslider({
              animation: "slide",
              animationLoop: false,
              itemWidth: 300,
              itemMargin: 30,
              controlNav: false,
              customDirectionNav: $(".tp-testimonial__nav a"),
              minItems: 1, // use function to pull in initial value
              maxItems: 2, // use function to pull in initial value
            });

        });
      }
    },
    'getting_here': {
      finalize: function() {
        $(document).ready(function(){
          $('.tp-transpot__option').click(function(){
            $index = $(this).index();
            $('.tp-transpot__list').removeClass('-active');
            $('.tp-transpot__list').eq($index).addClass('-active');
          });
        });
      }
    },        
    // About us page, note the change from about-us to about_us.
    'single': {
      finalize: function() {
        // JavaScript to be fired on the about us page
        $(document).ready(function(){
          $('#carousel').flexslider({
            animation: "slide",
            controlNav: false,
            animationLoop: false,
            slideshow: false,
            itemWidth: 80,
            itemMargin: 16,
            asNavFor: '#slider'
          });
         
          $('#slider').flexslider({
            animation: "slide",
            controlNav: false,
            animationLoop: false,
            slideshow: false,
            sync: "#carousel"
          });
        });

      }
    }
  };

  
  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
